<template>
  <div>
    <van-loading v-if="loading" color="#0094ff" />
    <div v-else class="templateSend">
      <div class="navBar">
        <!-- <p class="title">{{ifDetail ? '会议详情' : '会议确认'}}</p> -->
        <p class="title">{{ $t('会议详情') }}</p>
      </div>
      <div class="mainContent">
        <div class="mettingBoard">
          <!-- <van-field
          v-model="theme"
          type="textarea"
          autosize
          readonly
          class="mettingTitle"
          rows="1"
        /> -->
          <div class="mettingTitle">{{ theme }}</div>
          <div class="mettingLine"></div>
          <div class="mettingTimeDay">{{ timeDay }}</div>
          <div class="mettingTimeLine">{{ timeLine }}</div>
          <div class="mettingState">{{ state }}</div>
          <div class="mettingDet">
            <img src="@/assets/images/people.png" alt="" />
            <div class="mettingName">
              {{ $t('订会人：') }}{{ inviteName }}
              <!-- {{ getText(infoId) }} -->
            </div>
          </div>
          <div class="mettingDet">
            <img class="location" src="@/assets/images/location_icon.png" alt="" />
            <div class="mettingName">
              {{ $t('地点：') }}{{ !ifOnline ? area : $t('线上') }}
            </div>
          </div>
          <div class="mettingDetLast">
            <img src="@/assets/images/report.png" alt="" />
            <div class="mettingName">{{ $t('关联会议：') }}</div>
            <div class="mettingBlue" @click="mettingInfo(relationMeetingId)">
              {{ relationMeeting }}
            </div>
          </div>
          <!-- <div class="mettingDet" v-if="isReviewed">
            <img class="location" src="@/assets/images/phone.png" alt="" />
            <div class="mettingName">
              {{ '手机号：' }}{{ meetingStaffMobile }}
            </div>
          </div> -->
          <div class="mettingDet">
            <img class="location" src="@/assets/images/starLevel.png" alt="" />
            <div class="mettingName">
              {{ $t('会议等级：') }}{{ meetingLevel }}
            </div>
          </div>
          <div class="mettingDet" v-if="openMeetingService && meetingManger">
            <img class="location" src="@/assets/images/aixin.png" alt="" />
            <div class="mettingName">{{ $t('会务管理人：') }}</div>
            <div class="mettingNameLong">{{ meetingManger }}</div>
          </div>
          <div
            class="mettingDet"
            v-if="openMeetingService && servicePersonnerl"
          >
            <img class="location" src="@/assets/images/aixin.png" alt="" />
            <div class="mettingName">{{ $t('会务服务人：') }}</div>
            <div class="mettingNameLong">{{ servicePersonnerl }}</div>
          </div>
        </div>
        <div class="allPeoples">
          <div class="peoples">
            <div class="attendee">{{ $t('参会人') }}</div>
            <div class="tips" v-show="!ifDetail && isOwner">
              {{ $t('点击参会人员可以再次提醒参会') }}
            </div>
          </div>
          <div class="peoples-warp">
            <div v-for="(item, idx) in meetingList" :key="idx" :class="item.agree || item.agree == false
              ? 'peoples-box'
              : 'peoples-nobox'
              " :style="getStyle(item)" @click="doToast(item)">
              <div>
                {{ item.staffName }}
                <!-- {{ getText(item?.staffId) }} -->
              </div>
              <div v-if="item.agree || item.agree == false" class="people-status">
                <img src="@/assets/images/right_icon.png" alt="" v-if="item.agree" />
                <img src="@/assets/images/refuse_icon.png" alt="" v-if="!item.agree" />
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="themeCade">
        <div class="title">参会状态：</div>
        <div class="content">{{ state }}</div>
      </div> -->
        <div v-show="isShowVideo" class="metting-content">
          <div class="attendeeTitle">
            {{
              isVideoconferencing == '3'
                ? $t('钉钉视频会议')
                : isVideoconferencing == '1'
                  ? $t('腾讯视频会议')
                  : $t('企微视频会议')
            }}
          </div>
          <div class="tencent-info">
            <div class="noUrl">
              <div class="encryption-text">{{ $t('入会链接：') }}</div>
              <div class="encryption-text-g" v-if="!meetingUrl && state == $t('已取消')">
                {{ $t('已取消') }}
              </div>
            </div>
            <div class="tencent-text" v-if="meetingUrl">{{ meetingUrl }}</div>
            <div class="copy" @click="copyTencentInfo(meetingUrl)" v-if="meetingUrl">
              {{ $t('复制') }}
            </div>
            <div class="noUrl">
              <div class="encryption-text">{{ $t('会议号：') }}</div>
              <div class="encryption-text-g" v-if="!meetingCode">
                {{ $t('已取消') }}
              </div>
            </div>
            <div class="tencent-block" v-if="meetingCode">
              <div class="tencent-text">{{ meetingCode }}</div>
              <div class="copy" @click="copyTencentInfo(meetingCode)">
                {{ $t('复制') }}
              </div>
            </div>
          </div>
        </div>
        <div class="themeCadeOther">
          <div class="attendeeTitle">{{ $t('会议议程') }}</div>
          <div v-if="!mettingContent" class="no-Text">
            <div>{{ $t('暂无会议议程') }}</div>
          </div>
          <div v-if="mettingContent">
            <div v-html="mettingContent" class="html-Text"></div>
            <!-- <van-field v-model="mettingContent" type="textarea" class="theme" autosize readonly rows="1" /> -->
          </div>
        </div>
        <div class="themeCadeOther" v-show="!ifOnline">
          <div class="attendeeTitle">{{ $t('附件') }}</div>
          <div v-if="!filedList || !filedList.length" class="no-Text">
            <div>{{ $t('暂无附件') }}</div>
          </div>
          <div class="filedList" v-else>
            <div v-for="item in filedList" :key="item.uid" @click="showFiled(item)">
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="allPeoples">
          <div class="peoples">
            <div class="attendee">{{ $t('会议纪要') }}</div>
            <div class="tips" v-if="state == $t('已取消') || isBeforeTime">
              {{ $t('会议开始后可查看或上传纪要内容') }}
            </div>
            <div class="tipsBlue" v-else>{{ num }}{{ $t('人上传') }}</div>
          </div>
          <div v-if="state != $t('已取消') && !isBeforeTime">
            <div v-if="!meetingSummaryList || !meetingSummaryList.length" class="no-Text">
              <div>{{ $t('暂无纪要') }}</div>
            </div>
            <div v-else>
              <div v-for="(item, index) in meetingSummaryList" :key="item.id" :name="index" class="summaryCard">
                <div class="collTitel">
                  <div class="collTimeTitel">
                    <div class="collName">
                      {{ $t('上传人：') }}{{ item.staffName }}
                    </div>
                    <div class="collTime">{{ item.time }}</div>
                  </div>
                  <div class="summaryDelete" v-if="item.staffId == user.id">
                    <div class="summaryDeleteButton" @click="deleteSummary(item.id)">
                      {{ $t('删除') }}
                    </div>
                  </div>
                </div>
                <Summary :summaryInfo="item" :click="showSummaryImage" />
              </div>
            </div>
          </div>
          <div v-if="
            state != $t('已取消') &&
            !isBeforeTime &&
            mySummary < 3 &&
            isSummaryUser
          ">
            <div class="attendeeTitle">{{ $t('上传纪要') }}</div>
            <van-field v-model="summaryTheme" type="textarea" :placeholder="$t('请输入纪要内容')" clearable center rows="2"
              class="summaryTheme" autosize @change="summaryInfo" />
            <van-uploader v-model="imageList" multiple :max-count="3" :after-read="afterRead" @delete="deleteImag" />
            <div class="summaryFooter">
              <div class="summaryButton" @click="sendSummary()">
                {{ $t('发送') }}
              </div>
            </div>
          </div>
        </div>
        <div class="themeCadeOther">
          <div class="attendeeTitle">{{ $t('留言') }}</div>
        </div>
        <div v-if="!remarkList || !remarkList.length" class="no-uesdMeetingRoom">
          <img src="@/assets/images/empty.png" alt="" />
          <div>{{ $t('暂无留言') }}</div>
        </div>
        <div v-for="item in remarkList" :key="item.createdTime" class="remarkCade">
          <div class="remark-name">
            <div class="remark-title">
              <div class="remark-titleName">{{ item.name }}</div>
              <img :src="item.agree !== 'null'
                ? item.agree === 'agree'
                  ? agreeIcon
                  : rejectIcon
                : unIcon
                " alt="" />
            </div>
            <div class="remark-info">
              {{ dayjs(item.createdTime).format($t('M月D日HH:mm')) }}
            </div>
          </div>
          <div class="remarkBox">{{ item.remark }}</div>
        </div>
        <div class="btnBOX" v-if="showContinueBtn">
          <van-button round block type="info" native-type="submit" class="btn-style" @click="onContinueCheck(true)"
            :style="{ background: '#009BFF' }">{{ $t('继续会议') }}</van-button>
        </div>
        <div class="rejectBox" v-if="showBtn">
          <div v-if="showReject" class="refuseStyle" @click="
            () => {
              this.ifAgree = false
              this.showRefuse = true
            }
          ">
            {{ $t('拒绝') }}
          </div>
          <div class="confirmStyle" @click="checkRepeat" v-if="showReject">
            {{ $t('同意') }}
          </div>
        </div>
        <div class="footerBox">
          <div v-if="isOwner == true && state != $t('已取消') && !isTimeOut" class="twoPart">
            <div class="shortMessage" @click="showMessageCard()">
              {{ message ? message : $t('请输入留言') }}
              <div class="greyText">{{ messageNum }}/150</div>
            </div>
            <div
              :class="isEdit && !isReviewed ? 'edit' : 'noEdit'"
              @click="isEdit && !isReviewed ? gotoMetting() : null"
            >
              {{ $t('编辑会议') }}
            </div>
          </div>
          <div v-else class="onePart">
            <div class="longMessage" @click="showMessageCard()">
              {{ message ? message : $t('请输入留言') }}
              <div class="greyText">{{ messageNum }}/150</div>
            </div>
          </div>
        </div>
      </div>
      <van-popup v-model="showMessage" position="bottom" :style="{ height: 100 }">
        <div class="messagePopup">
          <div class="wrapper" :class="hasBottom ? 'bottomStyle' : ''">
            <van-field v-model="message" rows="1" autosize autofocus type="textarea" maxlength="120"
              :placeholder="$t('请输入留言')" show-word-limit ref="getFocus" @input="messageChange" class="messageField" />
          </div>
          <div class="meaasgeFooter">
            <div class="meaasgeFooterButton" @click="saveRemark(false)">
              {{ $t('确定') }}
            </div>
          </div>
        </div>
      </van-popup>
      <!-- <div class="btnBOX" v-if="showReject && showBtn">
      <van-button
        round
        block
        type="info"
        native-type="submit"
        class="btn-style"
        @click="checkRepeat"
        :style="{ background: '#009BFF' }"
      >
        同意
      </van-button>
      <div class="agreeBox" v-if="showReject">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          class="btn-small"
          @click="showRemark = true"
          :style="{ background: '#FFFFFF', color: '#009BFF', border: '1px solid #009BFF' }"
        >
          留言
        </van-button>
        <van-button
          round
          block
          type="info"
          native-type="submit"
          class="btn-small"
          @click="
            () => {
              this.ifAgree = false
              this.showRefuse = true
            }
          "
          :style="{ background: '#FF4D4F', color: '#FFFFFF', border: '1px solid #FF4D4F' }"
          >拒绝</van-button
        >
      </div>
    </div>
    <div v-else class="btnBOX" :style="{ marginTop: '13.33vw' }">
      <van-button
        round
        block
        type="info"
        native-type="submit"
        class="btn-style"
        @click="showRemark = true"
        :style="{ background: '#FFFFFF', color: '#009BFF', border: '1px solid #009BFF' }"
      >
        留言
      </van-button>
      <div class="footer"></div>
    </div> -->
      <van-image-preview v-model="showSummaryImg" :images="summaryImgUrl"></van-image-preview>
      <van-image-preview v-model="showImg" :images="imagesUrl"></van-image-preview>
      <van-popup v-model="isShowFiled" position="bottom" :style="{ height: '100%' }">
        <div class="offLineTitle">
          <div class="offLineTitlText">附件预览</div>
          <div class="offLineTitlClose" @click="isShowFiled = false">
            <van-icon name="cross" size="24px" />
          </div>
        </div>
        <iframe :src="url" width="100%" height="100%" frameborder="1" v-if="filedType == 'text'">
        </iframe>
        <iframe :src="url" width="100%" height="100%" frameborder="1" v-if="filedType == 'pdf'">
        </iframe>
        <video-player ref="videoPlayer" :playsinline="true" :options="playerOptions" v-if="filedType == 'video'"
          :style="{ height: '100%' }"></video-player>
      </van-popup>
      <van-dialog v-model="showRefuse" show-cancel-button confirmButtonColor="#009BFF" cancelButtonColor="#009BFF"
        @confirm="ifAgree ? onCheck(true) : onCheck(false)" class="outsiderStyle" :cancelButtonText="$t('取消')"
        :confirmButtonText="$t('确认')" :beforeClose="checkRemark">
        <template #title>
          <div class="outsider-title">
            {{ ifAgree ? $t('同意参会') : $t('拒绝参会') }}
          </div>
        </template>
        <div class="remark-box margin8">
          <van-field v-model="message" rows="2" autosize type="textarea" maxlength="50"
            :placeholder="ifAgree ? $t('请输入留言') : $t('请填写原因说明')" :required="!ifAgree" :error="!ifAgree && !message"
            size="14px" />
        </div>
      </van-dialog>
      <van-dialog v-model="showRepeat" show-cancel-button confirmButtonColor="#009BFF" cancelButtonColor="#009BFF"
        @confirm="onCheck(true)" class="outsiderStyle" :cancelButtonText="$t('取消')" :confirmButtonText="$t('确认')">
        <template #title>
          <div class="repeat-title">{{ $t('同意参会') }}</div>
        </template>
        <div class="repeat-box">
          <div class="repeat-tip">
            {{
              $t(
                '本次会议时间段与您参与的以下会议存在时间重叠，是否确认继续参会？'
              )
            }}
          </div>
          <div :style="{
            paddingBottom: repeatList.length == 1 ? '1.07vw' : '2.13vw',
          }" class="repeat-info">
            <div v-for="item in repeatList" :key="item.appointmentId" class="repeat-info-box">
              <div>{{ item.appointmentTopic }}</div>
              <div>
                {{ dayjs(item.beginTime).format('HH:mm') }}-{{
                  dayjs(item.endTime).format('HH:mm')
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="remark-box margin-repaet">
          <van-field v-model="message" rows="2" autosize type="textarea" maxlength="50" :placeholder="$t('请输入留言')"
            size="14px" />
        </div>
      </van-dialog>
      <!-- <van-dialog
      v-model="showRemark"
      show-cancel-button
      confirmButtonColor="#009BFF"
      cancelButtonColor="#009BFF"
      @confirm="saveRemark"
      class="outsiderStyle"
      cancelButtonText="取消"
      confirmButtonText="确认"
    >
      <template #title>
        <div class="outsider-title">会议留言</div>
      </template>
      <div class="remark-box margin8">
        <van-field
          v-model="message"
          rows="2"
          autosize
          type="textarea"
          maxlength="50"
          placeholder="请输入留言"
          size="14px"
        />
      </div>
    </van-dialog> -->
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import Vue from 'vue'
import Summary from '@/components/summary'
import {
  getAppointmentByID,
  checkUsing,
  notifyAppointment,
  getStaffById,
  dateOverlap,
  getMeetingMessage,
  saveMeetingMessage,
  getWorkspace,
  uploadBigFiles,
  queryMeetingSummary,
  addMeetingSummary,
  deleteMeetingSummary,
  queryPeopleCount,
  queryStaffToekn,
  getUserList,
  getCompanyInfo,
  addButtonApi,
} from '@/services/api'
import {
  Icon,
  Button,
  Toast,
  Dialog,
  Popup,
  ImagePreview,
  Field,
  Uploader,
  Collapse,
  CollapseItem,
  Loading,
} from 'vant'
import VideoPlayer from 'vue-video-player'
import copy from 'copy-to-clipboard'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(ImagePreview)
Vue.use(VideoPlayer)
Vue.use(Icon)
Vue.use(Button)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Field)
Vue.use(Popup)
Vue.use(Uploader)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Loading)

export default {
  name: 'TemplateSend',
  components: {
    Summary,
  },
  data() {
    return {
      user: {},
      theme: '',
      area: '',
      timeDay: '',
      timeLine: '',
      meetingStaffMobile: '',
      meetingLevel: '',
      meetingManger: '',
      servicePersonnerl: '',
      isReviewed: false,
      openMeetingService: false,
      relationMeeting: '',
      relationMeetingId: 0,
      meetingList: [],
      appointmentId: '',
      companyCode: '',
      agree: true,
      ifPast: false,
      showBtn: false,
      state: null,
      inviteName: '',
      isShowVideo: false,
      meetingCode: '',
      meetingUrl: '',
      orderName: '',
      isOwner: false,
      mettingContent: '',
      isTimeOut: false,
      isBeforeTime: false,
      filedList: '',
      url: '',
      filedName: '',
      isShowFiled: false,
      filedType: '',
      showImg: false,
      showSummaryImg: false,
      summaryImgUrl: [],
      ifOnline: false,
      imagesUrl: [],
      playerOptions: {
        autoplay: true, //是否自动播放
        muted: false, //是否静音播放
        loop: false, //是否循环播放
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9', //比例
        fluid: true,
        sources: [
          {
            type: '',
            src: '',
          },
        ],

        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      },
      showBtn: false,
      showReject: false,
      showRefuse: false,
      showRepeat: false,
      repeatList: [],
      ifAgree: false,
      meetingData: {},
      message: '',
      messageNum: 0,
      hasBottom: false,
      showMessage: false,
      hasFocus: false,
      showRemark: false,
      remarkList: [],
      agreeIcon: require('@/assets/images/remark_true_icon.png'),
      rejectIcon: require('@/assets/images/remark_false_icon.png'),
      unIcon: require('@/assets/images/remark_un_icon.png'),
      ifDetail: false,
      meetingRoom: [],
      num: 0,
      meetingSummaryList: [],
      isSummaryUser: false,
      summaryTheme: '',
      summaryPhoto: [],
      imageList: [],
      mySummary: 0,
      clickName: [],
      storageImg: [],
      isSaveRemark: true,
      userList: [],
      infoId: '',
      loading: true,
      checkState: false,
      isVideoconferencing: 0,
      isEdit: false,
    }
  },
  methods: {
    async getPermissions(companyId) {
      let companyCode = JSON.parse(localStorage.getItem('companyCode')).code
        ? JSON.parse(localStorage.getItem('companyCode')).code
        : JSON.parse(localStorage.getItem('cCode')).code
      try {
        let companyMsg = await getCompanyInfo(companyCode)

        if (companyMsg.corpid) {
          localStorage.setItem('isVideoconferencing', '3')
          this.isVideoconferencing = '3'
        } else if (companyMsg.qwAppId) {
          localStorage.setItem('isVideoconferencing', '2')
          this.isVideoconferencing = '2'
        } else {
          let oaInfo = await addButtonApi(companyId)
          if (
            oaInfo &&
            Object.values(oaInfo).includes('TENCENT_VIDEO_CONFERENCE')
          ) {
            localStorage.setItem('isVideoconferencing', 1)
            this.isVideoconferencing = '1'
          } else {
            localStorage.setItem('isVideoconferencing', '5')
            this.isVideoconferencing = '5'
          }
        }
        this.isEdit = true
      } catch (error) {
        console.log(error)
      }
    },
    getMeetingRecord(value) {
      if (!value) {
        return ''
      }
      const urlRegex = /https?:\/\/(?:www\.)?[^\s/$.?#].[^\s]*/g
      // 替换URL为特定的HTML标签，例如<a>标签
      value = value.replace(/\n/g, ' <br>')
      return value.replace(urlRegex, function (url) {
        return `<a href="${url}" target="_self">${url}</a>`
      })
    },
    async getInfo(appointmentId) {
      const info = await getAppointmentByID({ appointmentId })
      const res = await getUserList({ companyId: this.user.companyId })
      this.userList = res
      this.meetingData = info
      this.infoId = info.appointmentStaff
      if (info.isVideoconferencing && info.isVideoconferencing == 1) {
        this.isShowVideo = true
      } else {
        this.isShowVideo = false
      }
      this.meetingCode = info?.meetingCode ? info.meetingCode : ''
      this.meetingUrl = info?.meetingUrl ? info.meetingUrl : ''
      if (!info.summaryUserDetails) {
        this.isSummaryUser = false
      } else if (info.summaryUserDetails) {
        info.summaryUserDetails.map((item) => {
          if (item.staffId == this.user.id) {
            this.isSummaryUser = true
          }
        })
      }
      if (info.appointmentStaff == this.user.id) {
        this.isOwner = true
      }
      if (info.attach) {
        let filed = JSON.parse(info.attach)
        this.filedList = filed
      }
      // if (info.meetingPeopleId.split(',').length > info.attendDetails.length) {
      //   const { name } = await getStaffById(info.appointmentStaff)
      //   info.attendDetails.push({
      //     agree: 'true',
      //     staffId: info.appointmentStaff,
      //     staffName: name,
      //   })
      // }
      info.attendDetails.forEach((item) => {
        if (info.appointmentStaff == item.staffId) {
          this.inviteName = item.staffName
        }
        if (
          info.replaceAppointmentStaff &&
          info.replaceAppointmentStaff == item.staffId
        ) {
          this.orderName = '(' + item.staffName + this.$t('代预订)')
        }
        if (item.staffId == this.user.id) {
          this.agree = item.agree
          if (item.agree) {
            this.ifPast = true
          } else {
            this.showBtn = true
            this.showReject = true
          }
        }
      })
      this.theme = info.appointmentTopic
      this.relationMeeting = info.relationAppointmentTopic
      this.relationMeetingId = info.relationMeetingId
      let year = dayjs(info.appointmentStartTime).format(
        this.$t('YYYY年M月D日')
      )
      let startTime = dayjs(info.appointmentStartTime).format('HH:mm')
      let endTime = dayjs(info.appointmentEndTime).format('HH:mm')
      this.area =
        (info.meetingRoomDto && info.meetingRoomDto.name) || this.$t('线上')
      this.ifOnline = !(info.meetingRoomDto && info.meetingRoomDto.name)
      this.timeDay = year
      this.timeLine = startTime + this.$t('一') + endTime
      this.meetingList = info.attendDetails
      // this.meetingRoomId = info.meetingRoomDto.id
      this.mettingContent = this.getMeetingRecord(info.meetingRecord) || ''
      if (info.state == 'cancel') {
        this.state = this.$t('已取消')
        this.showBtn = false

        return
      } else if (this.user.id == info.appointmentStaff) {
        this.state = this.$t('已确认')
      } else {
        info.attendDetails.forEach((item) => {
          if (item.staffId == this.user.id) {
            !item.agree && (this.state = this.$t('未确认'))
            item.agree == true && (this.state = this.$t('已确认'))
            item.agree == false &&
              (this.state = this.$t('已拒绝')) &&
              (this.showReject = false)
          }
        })
      }
      if (dayjs(info.appointmentStartTime).valueOf() > dayjs().valueOf()) {
        this.isBeforeTime = true
      }
      if (
        info.actualEndTime &&
        dayjs(info.actualEndTime).valueOf() <= dayjs().valueOf()
      ) {
        this.ifPast = true
        this.isTimeOut = true
        this.showBtn = false
        this.showReject = false
        this.state = this.$t('已结束')
        this.isBeforeTime = false
      }
      if (dayjs().valueOf() >= dayjs(info.appointmentEndTime).valueOf()) {
        this.ifPast = true
        this.isTimeOut = true
        this.showBtn = false
        this.showReject = false
        this.state = this.$t('已结束')
        this.isBeforeTime = false
      }
      this.isReviewed = info.processMeetingId ? true : false
      this.meetingStaffMobile = info.meetingStaffMobile
        ? info.meetingStaffMobile
        : ''
      this.meetingLevel = info.meetingLevel
        ? info.meetingLevel == 1
          ? this.$t('1星')
          : info.meetingLevel == 2
          ? this.$t('2星')
          : info.meetingLevel == 3
          ? this.$t('3星')
          : this.$t('无')
        : this.$t('无')
      this.openMeetingService =
        info.openMeetingService !== undefined &&
        info.openMeetingService !== null
          ? info.openMeetingService
            ? true
            : false
          : false
      let manger = this.userList
        ? this.userList.filter((v) => v.id == info?.meetingManger)
        : []
      let servicePersonnerl = this.userList
        ? this.userList.filter((v) => v.id == info?.servicePersonnerl)
        : []
      this.meetingManger = manger && manger.length ? manger[0].name : ''
      this.servicePersonnerl =
        servicePersonnerl && servicePersonnerl.length
          ? servicePersonnerl[0].name
          : ''
    },
    async getSummary(id) {
      try {
        let params = {
          pageNum: 1,
          pageSize: 10000,
          meetingId: id,
        }
        const list = await queryMeetingSummary(params)
        const peopleNum = await queryPeopleCount({ meetingId: id })
        this.num = peopleNum
        let myNum = 0
        console.log('meetingSummary list:', list)
        if (list.results && list.results.length) {
          list.results.forEach((item) => {
            if (item.staffId == this.user.id) {
              myNum++
            }
            item.time = item.createdTime
              ? dayjs(item.createdTime, 'YYYY-MM-DD HH:mm:ss').format(
                this.$t('MM月DD日 HH:mm')
              )
              : ''
          })
        }
        this.meetingSummaryList = list.results
        this.mySummary = myNum
      } catch (error) {
        console.log(error)
      }
    },
    async onContinueCheck(bool) {
      try {
        await checkUsing({
          opinion: bool,
          staffId: this.user.id,
          appointmentRecordId: this.appointmentId,
        })
        Toast(this.$t('已为您延续会议室，请继续您的会议'))
      } catch (error) {
        console.log(error)
      }
    },
    getNowFormatDate(date) {
      let seperator1 = '-'
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      let currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    },
    async onCheck(bool) {
      if (!bool && !this.message) {
        return
      }
      let reject = false
      if (!bool) {
        reject = true
      }
      try {
        await checkUsing({
          opinion: bool,
          staffId: this.user.id,
          appointmentRecordId: this.appointmentId,
        })
        await this.saveRemark(reject)

        if (bool) {
          this.ifPast = true
          Toast.success(this.$t('已同意'))
          this.$router.push('/meeting')
        } else {
          this.ifPast = true
          this.showReject = false
          Toast.success(this.$t('已拒绝'))
          this.$router.push('/meeting')
        }
        this.agree = 'OK'
      } catch (error) {
        console.log(error)
      }
    },
    getStyle(date) {
      let style = {}
      if (date.agree || date.agree == false) {
        style.background = '#F4F4F4'
        style.color = '#666666'
      } else if (
        !this.isTimeOut &&
        this.isOwner &&
        this.state !== this.$t('已取消')
      ) {
        style.background = '#E6F7FF'
        style.color = '#2094FF'
      } else {
        style.background = '#F4F4F4'
        style.color = '#666666'
      }
      return style
    },
    async doToast(date) {
      if (
        !this.isOwner ||
        this.isTimeOut == true ||
        date.agree ||
        date.agree == false ||
        this.state == this.$t('已取消') ||
        this.ifDetail
      ) {
        return
      } else {
        try {
          await Dialog.confirm({
            title: this.$t('会议提醒'),
            message: this.$t('是否再次提醒[{slot1}]参会！', {
              slot1: date.staffName,
            }),
            messageAlign: 'center',
            cancelButtonText: this.$t('取消'),
            confirmButtonText: this.$t('确定'),
            confirmButtonColor: '#009BFF',
            cancelButtonColor: '#009BFF',
            allowHtml: true,
          })
          await notifyAppointment({
            id: this.appointmentId,
            meetingPeopleId: String(date.staffId),
          })
          Toast.success(this.$t('已通知参会人'))
        } catch (err) {
          console.log(err)
        }
      }
    },
    copyTencentInfo(value) {
      copy(`${value}`, {
        debug: true,
        message: 'Press #{key} to copy',
      })
      Toast.success(this.$t('已成功复制'))
    },
    showFiled(date) {
      this.url = date.url
      var suffix = ''
      var result = ''
      try {
        var name = date.name.split('.')
        suffix = name[name.length - 1]
      } catch (err) {
        suffix = ''
      }
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
      // 进行图片匹配
      result = imglist.some(function (item) {
        return item == suffix
      })
      if (result) {
        this.filedType = 'image'
        this.showImg = true
        this.isShowFiled = false
        this.imagesUrl = [date.url]
        return
      }
      // 匹配 文档
      var excelist = ['xls', 'xlsx', 'ppt', 'pptx']
      result = excelist.some(function (item) {
        return item == suffix
      })
      if (result) {
        this.filedType = 'text'
        this.showImg = false
        this.url =
          'https://view.officeapps.live.com/op/view.aspx?src=' + date.url
        this.isShowFiled = true
        return
      }
      // 匹配 pdf
      // var pdflist = ['pdf']
      // result = pdflist.some(function (item) {
      //   return item == suffix
      // })
      if (result) {
        this.filedType = 'pdf'
        this.showImg = false
        this.isShowFiled = true
        return
      }
      // 匹配 视频
      var videolist = ['mp4', 'mp3', 'mkv', 'wav', 'MP3', 'MP4']
      result = videolist.some(function (item) {
        return item == suffix
      })
      if (result) {
        this.filedType = 'video'
        this.showImg = false
        this.playerOptions.sources = [
          {
            type: '',
            src: date.url,
          },
        ]

        this.isShowFiled = true
        return
      }
      Dialog.confirm({
        message: this.$t('暂不支持该格式文档预览'),
        messageAlign: 'center',
        cancelButtonText: this.$t('取消'),
        confirmButtonText: this.$t('确定'),
        confirmButtonColor: '#009BFF',
        cancelButtonColor: '#009BFF',
        allowHtml: true,
      })
        .then(() => { })
        .catch(() => { })
      this.isShowFiled = false
    },
    async checkRepeat() {
      const res = await dateOverlap({
        staffIds: this.user.id,
        beginTime: this.meetingData.appointmentStartTime,
        endTime: this.meetingData.appointmentEndTime,
      })
      if (res.length) {
        let arr = res[0]?.dateOverlaps.filter(
          (item) => item.appointmentId != this.meetingData.id
        )
        if (arr.length) {
          this.repeatList = arr
          this.showRepeat = true
        } else {
          this.ifAgree = true
          this.showRefuse = true
        }
      } else {
        this.ifAgree = true
        this.showRefuse = true
      }
    },
    async getRemark(meetingId) {
      const res = await getMeetingMessage({ meetingId })
      this.remarkList = res
      this.loading = false
    },
    async saveRemark(reject) {
      if (this.isSaveRemark) {
        this.isSaveRemark = false
        this.showMessage = false
        let staffId = this.user.id
        await saveMeetingMessage({
          staffId,
          agree: reject ? 0 : null,
          remark: this.message,
          meetingId: this.meetingData.id,
        })
        this.message = ''
        this.messageNum = 0
        this.isSaveRemark = true
        this.getRemark(this.appointmentId)
      }
    },
    checkRemark(action, done) {
      if (action === 'confirm') {
        if (!this.message && !this.ifAgree) {
          done(false)
        } else {
          done()
        }
      } else {
        done()
        this.message = ''
      }
    },
    async getAreaId(developerId) {
      try {
        const res = await getWorkspace({
          developerId,
        })
        this.meetingRoom = [...res]
      } catch (error) {
        console.log(error.response.data.message)
      }
    },
    gotoMetting() {
      this.$router.push({
        name: 'MettingInfor',
        params: {
          mettingData: this.meetingData,
          mettingRoomList: this.meetingRoom,
          originDate: new Date(),
          ifOnline: this.ifOnline,
          ifAgain: 1,
        },
      })
    },
    async deleteSummary(id) {
      try {
        await Dialog.confirm({
          message: this.$t('是否确认删除纪要内容'),
          messageAlign: 'center',
          cancelButtonText: this.$t('取消'),
          confirmButtonText: this.$t('确定'),
          confirmButtonColor: '#009BFF',
          cancelButtonColor: '#009BFF',
          allowHtml: true,
        })
        await deleteMeetingSummary(id)
        Toast.success(this.$t('删除成功'))
        this.getSummary(this.appointmentId)
        this.clickName = []
      } catch (err) {
        console.log(err)
      }
    },
    async sendSummary() {
      if ((!this.imageList || !this.imageList.length) && !this.summaryTheme) {
        Toast.fail(this.$t('会议纪要不能为空'))
        return
      }
      try {
        let params = {
          attachmentVos: this.imageList,
          content: this.summaryTheme,
          meetingId: this.appointmentId,
          staffId: this.user.id,
        }
        await addMeetingSummary(params)
        Toast.success(this.$t('提交成功'))
        this.getSummary(this.appointmentId)
        localStorage.setItem(this.appointmentId + '', {})
        this.summaryPhoto = []
        this.summaryTheme = ''
        this.imageList = []
        this.storageImg = []
      } catch (error) {
        console.log(error)
      }
    },
    summaryInfo() {
      let params = {
        summaryTheme: this.summaryTheme,
        storageImg: this.storageImg,
      }
      localStorage.setItem(this.appointmentId + '', JSON.stringify(params))
    },
    async afterRead(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      let newUrl = await uploadBigFiles(formData)
      if (newUrl) {
        Toast.success(this.$t('图片加载成功'))
      } else {
        Toast.error(this.$t('图片加载失败'))
      }
      let imgList = this.storageImg
      imgList.push({ url: newUrl })
      this.storageImg = imgList
      this.imageList = imgList
      let params = {
        summaryTheme: this.summaryTheme,
        storageImg: this.storageImg,
      }
      localStorage.setItem(this.appointmentId + '', JSON.stringify(params))
    },
    deleteImag() {
      this.storageImg = this.imageList
      let params = {
        summaryTheme: this.summaryTheme,
        storageImg: this.storageImg,
      }
      localStorage.setItem(this.appointmentId + '', JSON.stringify(params))
    },
    getStorage() {
      let data = localStorage.getItem(this.appointmentId + '')
      if (data != null) {
        let newData = JSON.parse(data)
        console.log
        this.summaryTheme = newData.summaryTheme ? newData.summaryTheme : ''
        this.storageImg = newData.storageImg ? newData.storageImg : []
        this.imageList = newData.storageImg ? newData.storageImg : []
      } else {
        return
      }
    },
    showSummaryImage(url) {
      this.showSummaryImg = true
      this.summaryImgUrl = [url]
    },
    messageChange() {
      this.messageNum = this.message.length
    },
    showMessageCard() {
      this.showMessage = true
      this.$nextTick(() => {
        this.$refs.getFocus.focus()
      })
    },
    mettingInfo(id) {
      this.$router.push({
        name: 'MettingInforRead',
        query: {
          appointmentId: id,
        },
      })
    },
    async hasUser(user, token) {
      if (!user) {
        if (token) {
          const newUser = await queryStaffToekn({ token })
          if (newUser && newUser.token) {
            localStorage.setItem('user', JSON.stringify(newUser))
            localStorage.setItem(
              'cCode',
              JSON.stringify({ code: newUser.companyCode })
            )
            this.user = newUser
          } else {
            localStorage.setItem(
              'checkMeeting',
              JSON.stringify({ isTemplateSend: 'ok' })
            )
            this.$router.push(
              `/?appointmentId=${this.appointmentId}&companyCode=${this.companyCode}`
            )
          }
        } else {
          localStorage.setItem(
            'checkMeeting',
            JSON.stringify({ isTemplateSend: 'ok' })
          )
          this.$router.push(
            `/?appointmentId=${this.appointmentId}&companyCode=${this.companyCode}`
          )
        }
      } else {
        this.user = user
      }
      this.getPermissions(this.user.companyId)
      this.getInfo(this.appointmentId)
      this.getRemark(this.appointmentId)
      this.getAreaId(this.user.companyId)
      this.getSummary(this.appointmentId)
      this.getStorage()
    },
  },
  computed: {
    checkTest() {
      return (
        (this.agree == null || this.agree == undefined) && this.ifPast == false
      )
    },

    showContinueBtn() {
      return (
        this.state !== this.$t('已结束') &&
        this.state !== this.$t('已取消') &&
        (this.$route.query.state === 'check' ||
          this.$route.query.state?.includes('check'))
      )
    },
  },
  // watch: {
  //   showMessage() {
  //     if(this.showMessage){
  //       this.$refs.getFocus.focus()
  //     }
  //   },
  // },
  created() {
    this.isVideoconferencing = localStorage.getItem('isVideoconferencing')
    // this.$route.query.ifDetail && (this.ifDetail = true)
  },
  mounted() {
    this.appointmentId = this.$route.query.appointmentId
    this.companyCode = this.$route.query.companyCode
    this.checkState = this.$route.query.state
    let user = JSON.parse(localStorage.getItem('user'))
    let token = this.$route.query.token
    this.hasUser(user, token)
  },
}
</script>
<style lang="less" scoped>
.navBar {
  background: #ffffff;
  line-height: 50px;
  text-align: center;
  font-size: 18px;

  // border-bottom: 1px #ededed solid;
  .title {
    font-size: 17px;
    // font-weight: 500;
    color: #333333;
  }
}

.templateSend {
  height: 100%;
  background: #ffffff;
  color: #666666;
  position: relative;

  .mainContent {
    padding: 0 16px;
    background: #fefffe;
  }

  .mettingBoard {
    width: 343px;
    min-height: 208px;
    padding: 16px;
    background: #f4f4f4;
    border-radius: 4px;
    margin-bottom: 20px;

    /deep/.van-field__control {
      font-size: 20px;
      font-weight: 600;
      color: #202020;
    }

    .mettingTitle {
      padding: 0 6px;
      font-size: 20px;
      font-weight: 600;
      color: #202020;
      margin-bottom: 15px;
      background: #f4f4f4;
    }

    .mettingLine {
      width: 323px;
      height: 1px;
      background: rgba(0, 0, 0, 0.1);
      margin-bottom: 8px;
    }

    .mettingTimeDay {
      padding: 0 6px;
      font-size: 12px;
      font-weight: 400;
      color: #949494;
      line-height: 16px;
      margin-bottom: 4px;
    }

    .mettingTimeLine {
      padding: 0 6px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 24px;
      margin-bottom: 13px;
    }

    .mettingState {
      padding: 2px 4px;
      display: inline-flex;
      height: 22px;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      font-weight: 400;
      color: #1890ff;
      background: #e6f7ff;
      border-radius: 2px;
      border: 1px solid #91d5ff;
      margin-left: 6px;
      margin-bottom: 11px;
    }

    .mettingDet {
      padding: 0 6px;
      display: flex;
      align-items: center;
      margin-bottom: 8px;

      img {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }

      .mettingName {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 16px;
      }

      .mettingNameLong {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 16px;
        width: 190px;
        white-space: nowrap;
        /* 禁止换行 */
        overflow: hidden;
        /* 隐藏溢出内容 */
        text-overflow: ellipsis;
        /* 显示省略号 */
      }

      .mettingBlue {
        font-size: 14px;
        font-weight: 400;
        color: #1377ec;
        line-height: 16px;
        width: 190px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
    }

    .mettingDetLast {
      padding: 0 6px;
      display: flex;
      align-items: center;
      margin-bottom: 8px;

      img {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }

      .mettingName {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 16px;
      }

      .mettingBlue {
        font-size: 14px;
        font-weight: 400;
        color: #1377ec;
        line-height: 16px;
        width: 190px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
    }
  }

  .rejectBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
  }

  .refuseStyle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 166px;
    height: 44px;
    background: #ff4d4f;
    border-radius: 24px;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    line-height: 24px;
  }

  .confirmStyle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 166px;
    height: 44px;
    background: #009bff;
    border-radius: 24px;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    line-height: 24px;
  }

  .footerBox {
    width: 100%;
    margin-top: 24px;
    padding-bottom: 30px;

    // padding-bottom: constant(safe-area-inset-bottom);
    // padding-bottom: env(safe-area-inset-bottom);
    .greyText {
      font-size: 13px;
      font-weight: 400;
      color: #aaaaaa;
      line-height: 24px;
      float: right;
      margin-left: 15px;
      display: flex;
      align-items: flex-end;
      shape-outside: inset(calc(100% - 100px) 0 0);
    }

    .twoPart {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .shortMessage {
        padding: 10px 10px;
        margin-right: 7px;
        width: 246px;
        min-height: 40px;
        background: #f9f9f9;
        border-radius: 24px;
        line-height: 24px;
        white-space: pre-wrap;
        word-break: break-all;
        font-size: 13px;
        font-weight: 400;
        color: #aaaaaa;
        word-spacing: 2px;
      }

      .edit {
        width: 88px;
        height: 41px;
        background: #009bff;
        border-radius: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
      }

      .noEdit {
        width: 88px;
        height: 41px;
        background: #949494;
        border-radius: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
      }
    }

    .onePart {
      width: 100%;

      .longMessage {
        padding: 10px 10px;
        width: 100%;
        min-height: 40px;
        background: #f9f9f9;
        border-radius: 24px;
        line-height: 24px;
        white-space: pre-wrap;
        word-break: break-all;
        font-size: 13px;
        font-weight: 400;
        color: #aaaaaa;
        word-spacing: 2px;
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
      }
    }
  }

  .btnBOX {
    // position: absolute;
    // left: 0;
    // bottom: 0;
    width: 100%;
    margin-top: 24px;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    margin-bottom: 10px;

    .agreeBox {
      margin-top: 16px;
      margin-bottom: 23px;
      display: flex;
    }
  }
}

.btn-style {
  width: 351px;
  height: 44px;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 500;
  margin: 0 auto;
  border: none;
}

.btn-small {
  width: 170px;
  height: 44px;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 500;
  margin: 0 auto;
  border: none;
}

.allPeoples {
  margin-bottom: 20px;

  .peoples-warp {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
  }

  .peoples-box {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 64px;
    height: 32px;
    border-radius: 2px;
    // border: 1px solid #f4f4f4;
    margin-right: 8px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    padding: 0 10px 0 6px;
    margin-bottom: 12px;
  }

  .peoples-nobox {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 64px;
    height: 32px;
    border-radius: 2px;
    // border: 1px solid #f4f4f4;
    margin-right: 8px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    padding: 0 18px;
    margin-bottom: 12px;
  }

  .people-status {
    margin-left: 7px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 14px;
      height: 14px;
    }
  }
}

.peoples {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 12px;

  .tips {
    font-size: 12px;
    font-weight: 400;
    color: #aaaaab;
    line-height: 16px;
  }

  .tipsBlue {
    font-size: 12px;
    font-weight: 400;
    color: #009bff;
    line-height: 16px;
  }
}

.attendee {
  font-size: 20px;
  font-weight: 600;
  color: #202020;
  line-height: 24px;
}

.attendeeTitle {
  font-size: 20px;
  font-weight: 600;
  color: #202020;
  line-height: 24px;
  margin-bottom: 9px;
}

.themeCade {
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px #ededed solid;
  height: 55px;
  font-size: 16px;

  .title {
    width: 90px;
    color: #333333;
  }

  .content {
    color: #666666;
  }
}

.filedList {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  color: #1377ec;

  div {
    margin-bottom: 8px;
  }
}

.themeCadeFiled {
  background: #fefffe;
  font-size: 16px;

  .title {
    color: #333333;
    height: 36px;
    line-height: 36px;
    width: 80px;
    border-bottom: 1px solid #ededed;
  }
}

.themeCadeOther {
  margin-bottom: 17px;

  .title {
    width: 90px;
    color: #333333;
    margin-bottom: 5px;
  }

  .content {
    color: #666666;
  }

  .theme {
    // width: calc(100% - 90px) !important;
    width: 100%;
    font-size: 24px;
    padding: 0 !important;
    color: #666666 !important;
  }
}

.van-field__control {
  color: #666666 !important;
  font-size: 24px !important;
}

.van-dialog {
  border-radius: 4px !important;
}

/deep/.van-cell::after {
  border: none;
}

/deep/.outsiderStyle {
  width: 296px;

  .outsider-title {
    font-size: 18px;
    line-height: 24px;
  }

  .van-cell::after {
    border: none;
  }

  .van-dialog__header {
    padding: 32px 0px 13px;
  }

  .cancel-box {
    font-size: 14px;
    color: #666666;
    line-height: 24px;
    padding: 0 0 20px 49px;

    .first-cancel {
      margin-bottom: 7px;
    }
  }

  .refuse-box {
    font-size: 14px;
    color: #666666;
    line-height: 24px;
    padding: 10px 0 41px;
    display: flex;
    justify-content: center;
  }

  .van-field__label {
    margin-left: 19px;
    width: 29px;
    line-height: 36px;
    font-size: 14px;
    margin-right: 8px;
  }

  .outsider-input {
    border: 1px solid rgba(0, 0, 0, 0.15);
    height: 36px;
    padding-left: 8px;
    width: 192px;
  }

  input::-webkit-input-placeholder {
    color: #cfcfcf;
  }

  input::-moz-placeholder {
    color: #cfcfcf;
  }

  input:-moz-placeholder {
    color: #cfcfcf;
  }

  input:-ms-input-placeholder {
    color: #cfcfcf;
  }
}

.repeat-title {
  margin-top: -8px;
}

.repeat-box {
  margin-top: -5px;

  .repeat-tip {
    padding: 0 26px;
    font-size: 14px;
    color: #666666;
    line-height: 24px;
    margin-bottom: 16px;
  }
}

.repeat-info {
  padding-left: 21px;
  padding-right: 21px;
  font-size: 12px;
  color: #999999;
  line-height: 24px;

  .repeat-info-box {
    display: flex;
    justify-content: space-between;
  }
}

.remark-box {
  width: 224px;
  min-height: 80px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;

  /deep/.van-cell {
    align-items: flex-start !important;
  }
}

.margin8 {
  margin: 0 auto 8px;
}

.margin-repaet {
  margin: 8px auto 16px;
}

.remarkCade {
  width: 100%;
  margin-bottom: 33px;

  .remark-name {
    font-size: 16px;
    color: #666666;
    line-height: 24px;
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    padding-right: 7px;

    .remark-title {
      display: flex;
      align-items: center;

      .remark-titleName {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        line-height: 16px;
        margin-right: 8px;
      }

      img {
        width: 40px;
        height: 16px;
      }
    }
  }

  .remark-info {
    font-size: 11px;
    font-weight: 400;
    color: #aaaaab;
    line-height: 16px;
  }

  .remarkBox {
    font-size: 14px;
    font-weight: 400;
    color: #5e5e5e;
    line-height: 16px;
    white-space: pre-wrap;
    word-break: break-all;
  }
}

.footer {
  height: 5px;
  margin-top: 5px;
}

.no-Text {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  line-height: 24px;
  color: #aaaaab;
  font-size: 16px;
  margin-bottom: 20px;
}

.html-Text {
  font-size: 16px;
}

.no-uesdMeetingRoom {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 24px;
  color: #666666;
  font-size: 14px;
  margin-bottom: 33px;

  img {
    width: 96px;
    height: 61px;
    margin-bottom: 8px;
  }
}

.summaryCard {
  padding: 10px 10px 0;
  margin-bottom: 20px;
  background: #f7f7f7;
  border-radius: 2px;
}

.summaryTheme {
  font-size: 16px;
  font-weight: 400;
  color: #aaaaaa;
  line-height: 24px;
  padding: 0 !important;
}

.summaryFooter {
  display: flex;
  justify-content: end;
  align-items: center;
  width: 100%;
  margin-top: 10px;

  .summaryButton {
    width: 64px;
    height: 28px;
    background: rgba(0, 155, 255, 0.5);
    border-radius: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    font-weight: 400;
    color: #ffffff;
    line-height: 24px;
  }
}

.collTitel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.collTimeTitel {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.collName {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  line-height: 16px;
  margin-bottom: 2px;
}

.collTime {
  font-size: 11px;
  font-weight: 400;
  color: #aaaaab;
  line-height: 16px;
  margin-left: 2px;
}

// /deep/.van-cell {
//   align-items: center !important;
//   padding-left: 0 !important;
//   padding-right: 0 !important;
// }
// /deep/.van-collapse-item__content {
//   padding: 0;
//   color: #5e5e5e;
// }
.summaryText {
  font-size: 14px !important;
  padding: 0 !important;
}

.summaryImgList {
  display: flex;
  align-items: center;
  margin-top: 12px;
  margin-bottom: 9px;
}

.summaryImg {
  width: 80px;
  height: 80px;
  margin-right: 7px;
}

.summaryDelete {
  display: flex;
  align-items: center;
}

.summaryDeleteButton {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 28px;
  border-radius: 15px;
  border: 1px solid #ff4d4f;
  font-size: 13px;
  font-weight: 400;
  color: #ff4d4f;
  line-height: 24px;
}

.hide {
  height: 60px;
  overflow: hidden;
}

.messageCard {
  position: absolute;
  top: 0;
  left: 0;
  // bottom: 0;
  right: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.messagePopup {
  padding: 12px 10px;
  background: #f2f3f5;
}

.messageField {
  background: #ffffff;
  border-radius: 6px;
}

.meaasgeFooter {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.meaasgeFooterButton {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 85px;
  height: 28px;
  background: #009bff;
  border-radius: 24px;
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
  line-height: 24px;
}

/deep/.van-field__control {
  font-size: 16px;
  font-weight: 400;
  color: #aaaaab;
  line-height: 24px;
}

/deep/.van-field__word-limit {
  margin-right: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #aaaaaa;
  line-height: 24px;
}

.wrapper {
  width: 100%;
  overflow: hidden;
  position: relative;
  background: #ffffff;
  margin-bottom: 11px;
  border-radius: 6px;

  /deep/.van-cell {
    align-items: center !important;
    padding: 10px;
  }
}

.counter {
  position: absolute;
  right: 10px;
  bottom: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #aaaaaa;
  line-height: 24px;
  width: 40px;
}

.bottomStyle {
  padding-bottom: 24px;
}

.metting-content {
  margin-bottom: 17px;
}

.tencent-info {
  margin-top: 10px;
}

.tencent-text {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
}

.encryption-text {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  margin-top: 10px;
}

.encryption-text-g {
  font-size: 16px;
  font-weight: 400;
  color: #aaaaaa;
  line-height: 24px;
  margin-top: 10px;
}

.tencent-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.copy {
  width: 52px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  color: #1890ff;
  background: #e6f7ff;
  border-radius: 2px;
  border: 1px solid #91d5ff;
}
.offLineTitle {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.offLineTitlText {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
}

.offLineTitlClose {
  position: absolute;
  top: 12px;
  right: 20px;
}
</style>
